import { useCurrentRole, useIsAdmin } from "../api/auth.js";
import { useDefaultEngagement, useGrantPortalObject } from "../api/engagement-plan.js";
import {
  useCreateShareLink,
  useDeleteShareLink,
  useRevokeShareLink,
  useShareAudit,
  useShareLinks,
} from "../api/sharing.js";
import { useTenants } from "../api/tenants.js";
import {
  prefersSharePointCoEdit,
  useArchiveWorkspaceDocument,
  useCreateWorkspace,
  useCreateWorkspaceCollaborationSite,
  useCreateWorkspaceDocument,
  useDeleteWorkspaceCollaborationSite,
  useSharePointConfig,
  useUnarchiveWorkspaceDocument,
  useUploadSharePointVersion,
  useUploadWorkspaceVersion,
  useWorkspaceCollaborationSites,
  useWorkspaceDocumentEditUrl,
  useWorkspaceDocuments,
  useWorkspaces,
} from "../api/workspaces.js";
import { AskInsightsLink } from "../components/ai/AskInsightsDrawer.js";

import type { DocumentsHubServices } from "@l30/web-documents/host";

/**
 * Hub-side implementation of the `DocumentsHubServices` port (ADR-0101 Phase 4).
 *
 * `@l30/web-documents` must not import `packages/web/src/**`, so every
 * cross-domain hook/handoff it needs (auth, sharing, engagement/portal
 * grants, tenants, workspaces, Ask Insights) is proxied through this
 * factory and injected via `<DocumentsHubProvider>` (mounted in
 * `_authenticated.tsx`). This is a plain object of hook/function
 * references — not a hook itself — so it can be constructed once per
 * render without violating rules-of-hooks.
 */
export function createDocumentsHubServices(): DocumentsHubServices {
  return {
    useCurrentRole,
    useIsAdmin,

    AskInsightsLink,

    useTenants,

    useShareLinks,
    useCreateShareLink,
    useRevokeShareLink,
    useDeleteShareLink,
    useShareAudit,

    useDefaultEngagement,
    useGrantPortalObject,

    prefersSharePointCoEdit,
    useWorkspaces,
    useCreateWorkspace,
    useWorkspaceDocuments,
    useCreateWorkspaceDocument,
    useArchiveWorkspaceDocument,
    useUnarchiveWorkspaceDocument,
    useUploadWorkspaceVersion,
    useUploadSharePointVersion,
    useSharePointConfig,
    useWorkspaceCollaborationSites,
    useCreateWorkspaceCollaborationSite,
    useDeleteWorkspaceCollaborationSite,
    useWorkspaceDocumentEditUrl,
  };
}
